import React from "react";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import AdmissionGuidelines from "../../components/Admission/AdmissionGuidelines";
import FeeStructure from "../../components/Admission/FeeStructure";
import Applications from "../../components/Admission/Applications";
import { useSelector } from "react-redux";
import { isPermission, isRole } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";

const Admissions_main = () => {
   const permissions = useSelector(isPermission);
    const role=useSelector(isRole)
    const isAccessible = role=="schooladmin"|| permissions && permissions?.includes('view_Admissions') || false;

     if (!isAccessible) {
      return (
        <>
         <Error403Page/>
        </>
      );
    }
  return (
    <>
      <Title name="Admissions" />
      <Topbar title="Admissions" btn={true} btnName="FAQs" btnLink="/admissions/faqs" />
      <div className="p-6 space-y-6 pr-0">
        <AdmissionGuidelines />
        <FeeStructure />
        {/* <Applications /> */}
      </div>
    </>
  );
};

export default Admissions_main;
